const { cxt } = require('./context');

const {
  client,
} = require('../schema');

const {
  brandstore,
} = client;

/**
 * Validates the VX Core Sales Split from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const clientBrandStoreValidator = [
  cxt('schema', { schema: brandstore, opts: { nestedErrors: true } }),
];

const brandText = [
  cxt('pattern', { pattern: /^[A-Za-z0-9.?:@+ ]+$/ }),
];

const brandTextRequired = [
  'required',
  cxt('pattern', { pattern: /^[A-Za-z0-9.?:@+ ]+$/ }),
];

module.exports = {
  clientBrandStore: clientBrandStoreValidator,
  brandText,
  brandTextRequired,
};
